import React, { useEffect, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { connect, useSelector } from "react-redux";
import "../../config";
import axios from "axios";
import { format, set } from "date-fns";
import CountryFlag from "react-country-flag";
import { updateTransactionRequest } from "../common/customServiceCall/serviceCall";
import CustomDialog from "../common/tableComponent.js/dialog";

const qs = require("query-string");

const TransactionStatusUpdateReq = (props) => {
  const toast = useRef(null);
  const userDetails = useSelector((state) => state.login.userDetails);
  const [loading, setLoading] = useState(false);
  const [sysTransId, setSysTransId] = useState("");
  const [transId, setTransId] = useState("");
  const [country, setCountry] = useState(null);
  const [status, setStatus] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [requests, setRequests] = useState([]);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [selectedRequest, setselectedRequest] = useState(null);
  const [action, setAction] = useState("");
  const [actionLoading, setActionLoading] = useState(false);

  const token = userDetails._id;

  const statusFilter = [
    { label: "All", value: "" },
    { label: "Pending", value: "0" },
    { label: "Success", value: "1" },
    { label: "Failed", value: "2" },
    { label: "Processing", value: "3" },
    { label: "Low_Bal", value: "4" },
    { label: "Re_Queued", value: "5" },
    { label: "Cancelled", value: "6" },
    { label: "Back_Off", value: "7" },
    { label: "Queued_Fs_Failed", value: "8" },
    { label: "Retrieved", value: "77" },
  ];
  const statusMap = {
    PENDING: { label: "Pending", color: "orange" },
    SUCCESSFUL: { label: "Success", color: "green" },
    FAILURE: { label: "Failed", color: "red" },
    PROCESSING: { label: "Processing", color: "blue" },
    LOW_BAL: { label: "Low_Bal", color: "purple" },
    RE_QUEUED: { label: "Re_Queued", color: "gray" },
    CANCELLED: { label: "Cancelled", color: "black" },
    BACK_OFF: { label: "Back_Off", color: "darkorange" },
    QUEUED_FS_FAILED: { label: "Queued_Fs_Failed", color: "pink" },
    RETRIEVED: { label: "Retrieved", color: "teal" },
  };

  const handleCountryChange = (event) => {
    const selectedValue = event.value;
    setCountry(selectedValue); // Update the state
  };
  useEffect(() => {
    if (country !== null) {
      fetchData();
    }
  }, [country]);
  const statusTemplate = (rowData) => {
    const status = statusMap[rowData.status] || {
      label: "Unknown",
      color: "gray",
    };

    return (
      <p
        className="p-tag"
        style={{
          backgroundColor: status.color,
          color: "white", // Text color to contrast with the background
          padding: "5px 8px",

          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        {status.label}
      </p>
    );
  };
  const filterInputBoxStyle = { borderRadius: "4px", width: "100%" };

  const floatLabel = {
    fontWeight: "500",
    color: "rgb(153, 153, 153)",
    fontSize: "12px",
  };

  const handleViewModalDisplay = async (rowData) => {
    setselectedRequest(rowData);
    setShowViewModal(true);
  };

  const handleApproveModalDisplay = async (rowData) => {
    setselectedRequest(rowData);
    setShowApproveModal(true);
    setAction("APPROVE");
  };

  const handleDeclineModalDisplay = async (rowData) => {
    setselectedRequest(rowData);
    setShowDeclineModal(true);
    setAction("DECLINE");
  };

  const getSearchedData = () => {
    fetchData();
  };

  const dateTemplate = (rowData) => {
    return <p>{format(new Date(rowData.created_at), "yyyy-MM-dd HH:mm:ss")}</p>;
  };

  const renderStatusBadge = (status) => {
    const colorMap = {
      PENDING: "orange",
      SUCCESS: "green",
      FAILED: "red",
      PROCESSING: "blue",
      RE_QUEUED: "gray",
      CANCELLED: "black",
      BACK_OFF: "darkorange",
      QUEUED_FS_FAILED: "pink",
      RETRIEVED: "teal",
    };
    return (
      <span
        className="p-tag"
        style={{
          backgroundColor: colorMap[status] || "#ccc",
          color: "white",
          marginLeft: "8px",
          fontWeight: "bold",
        }}
      >
        {status}
      </span>
    );
  };

  const renderTypeBadge = (type) => {
    const colorMap = {
      SUCCESS: "green",
      FAILED: "red",
      PENDING: "orange",
      CANCELLED: "black",
    };
    return (
      <span
        className="p-tag"
        style={{
          backgroundColor: colorMap[type] || "#888",
          color: "white",
          marginLeft: "8px",
          fontWeight: "bold",
        }}
      >
        {type}
      </span>
    );
  };

  const fetchData = async () => {
    const formData = new FormData();

    formData.append("token", token);
    formData.append("status", "PENDING");

    try {
      setLoading(true);

      const response = await updateTransactionRequest(
        "post",
        `/completion/single/requests/filter`,
        formData
      );

      if (response.code === "00" || response.status === 200) {
        setRequests(response.data || []); // Set data or empty array
      } else {
        setRequests([]); // No data, clear the table
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const confirmAction = async (request_id) => {
    const formData = new FormData();

    formData.append("token", token);
    formData.append("action", action);
    formData.append("request_id", request_id);
    console.log("Approval request:::", request_id);

    try {
      setActionLoading(true);
      const response = await updateTransactionRequest(
        "post",
        `/completion/single/requests/approval`,
        formData
      );

      if (response.code === "00" || response.status === 200) {
        setShowApproveModal(false);
        setShowDeclineModal(false);
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.msg,
          life: 3000,
        });
        fetchData();
      } else {
        setShowApproveModal(false);
        setShowDeclineModal(false);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.msg,
          life: 3000,
        });
        console.error("Failed to approve request:", response.message);
      }
    } catch (error) {
      setShowApproveModal(false);
      setShowDeclineModal(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
        life: 3000,
      });
      console.error("Error approving request:", error);
    } finally {
      setActionLoading(false);
    }
  };

  const actions = (rowData) => (
    <>
      <Button
        label=""
        icon="pi pi-eye"
        className="p-button-warning p-mr-2"
        onClick={() => handleViewModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="View Details"
        data-for="toolTip1"
        data-place="top"
      />
      <Button
        label=""
        icon="pi pi-check-circle"
        className="p-button-success p-mr-2"
        onClick={() => handleApproveModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="Approve Request"
        data-for="toolTip1"
        data-place="top"
      />
      <Button
        label=""
        icon="pi pi-ban"
        className="p-button-danger p-mr-2"
        onClick={() => handleDeclineModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="Decline Request"
        data-for="toolTip1"
        data-place="top"
      />

      <ReactTooltip id="toolTip1" />
    </>
  );
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <section className="p-my-4 p-md-12 p-xl-12" style={{ padding: "0px 10%" }}>
      <Toast ref={toast} position="top-right" />
      <div className="layout-content">
        <div className="p-grid p-fluid p-mb-4">
          <div
            className="p-col-12 p-sm-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
            style={{ textAlign: "center" }}
          >
            <span className="p-tag custom-heading">
              Transaction Status Update Requests
            </span>
          </div>
        </div>

        <div className="card" style={{ paddingTop: "0px" }}>
          <div
            className="p-grid p-align-center p-justify-center p-fluid"
            style={{ paddingTop: "10px" }}
          >
            {/* Date Range Picker */}
            <div className=" p-col-12 p-md-3">
              <label style={floatLabel}>DATE RANGE</label>
              <span className="p-float-label">
                <Calendar
                  value={dateRange}
                  onChange={(e) => setDateRange(e.value)} // Set date range
                  selectionMode="range"
                  readOnlyInput
                  showIcon
                  placeholder="Select Date Range"
                />
              </span>
            </div>

            {/* Country */}
            <div className=" p-col-12 p-md-2">
              <label style={floatLabel}>COUNTRY</label>
              <span className="p-float-label">
                <Dropdown
                  style={filterInputBoxStyle}
                  id="dropdown1"
                  options={userDetails.allCountries.map((item) => ({
                    label: item.label,
                    value: item.value,
                  }))} // Populate dropdown from userDetails
                  value={country}
                  onChange={handleCountryChange}
                  autoWidth={false}
                  placeholder="Select a country"
                />
              </span>
            </div>

            {/* Status Dropdown */}
            <div className=" p-col-12 p-md-2 ">
              <label style={floatLabel}>STATUS</label>
              <span className="p-float-label">
                <Dropdown
                  value={status}
                  options={statusFilter}
                  onChange={(e) => setStatus(e.value)}
                  placeholder="Select Status"
                />
              </span>
            </div>

            {/* Search Input */}
            <div className=" p-col-12 p-md-2">
              <label style={floatLabel}>REQUEST ID</label>
              <div className="p-inputgroup">
                <InputText
                  value={transId}
                  onChange={(e) => setTransId(e.target.value)}
                  placeholder="Enter transId"
                />
              </div>
            </div>

            <div className=" p-col-12 p-md-2">
              <label style={floatLabel}>SYSTEM REQUEST ID</label>
              <div className="p-inputgroup">
                <InputText
                  value={sysTransId}
                  onChange={(e) => setSysTransId(e.target.value)}
                  placeholder="Enter sysTransId"
                />
              </div>
            </div>
            <div className=" p-col-12 p-md-1">
              <Button
                onClick={getSearchedData}
                icon="pi pi-search"
                className="p-button-info"
                style={{ marginTop: "20px" }}
              />
            </div>
          </div>
        </div>
        <div className="card">
          {loading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <ProgressSpinner
                style={{
                  display: userDetails.showLoader,
                  width: "40px",
                  height: "40px",
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  bottom: "50%",
                  right: "50%",
                  zIndex: "1111111111",
                }}
                strokeWidth="3"
                animationDuration=".5s"
              />
            </div>
          ) : (
            <DataTable
              value={requests}
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 25, 50]}
              tableStyle={{ minWidth: "60rem" }}
              className="p-datatable-responsive-demo"
            >
              <Column
                field="id"
                header="Request ID"
                style={{ width: "25%", fontSize: "13px" }}
              ></Column>
              <Column
                field="requested_by_name"
                header="Requested By"
                style={{ width: "25%", fontSize: "13px" }}
              ></Column>
              <Column
                field="institution_short_name"
                header="Institution Name"
                style={{ width: "25%", fontSize: "13px" }}
              ></Column>
              <Column
                field="createdAt"
                header="Created At"
                style={{ width: "25%", fontSize: "13px" }}
                body={dateTemplate}
              ></Column>

              <Column
                header="Actions"
                style={{ width: "25%", fontSize: "13px" }}
                body={actions}
              ></Column>
            </DataTable>
          )}
        </div>
        <>
          <CustomDialog
            visible={showViewModal}
            header="View Request Modal"
            onClose={() => setShowViewModal(false)}
          >
            {selectedRequest && (
              <div className="p-grid p-fluid transaction">
                <div style={{ marginBottom: "24px" }}>
                  <h4>Request Details</h4>
                  <div className="p-mb-3">
                    <>Request ID:</> {selectedRequest.id}
                  </div>
                  <div className="p-mb-3">
                    <>Transaction System ID:</>{" "}
                    {selectedRequest.transaction_system_id}
                  </div>
                  <div className="p-mb-3">
                    <>Transaction Pay ID:</>{" "}
                    {selectedRequest.transaction_pay_id}
                  </div>
                  <div className="p-mb-3">
                    <>Status:</> {renderStatusBadge(selectedRequest.status)}
                  </div>
                  <div className="p-mb-3">
                    <>Request Type:</>{" "}
                    {renderTypeBadge(selectedRequest.request_type)}
                  </div>
                  <div className="p-mb-3">
                    <>Created At:</> {selectedRequest.created_at}
                  </div>
                </div>

                <div style={{ marginBottom: "24px" }}>
                  <h4>Requestor Details</h4>
                  <div className="p-mb-3">
                    <>Requested By:</> {selectedRequest.requested_by_name} (
                    {selectedRequest.requested_by})
                  </div>
                  <div className="p-mb-3">
                    <>Institution name:</>{" "}
                    {selectedRequest.institution_short_name}
                  </div>
                </div>
              </div>
            )}
          </CustomDialog>
          <CustomDialog
            visible={showApproveModal}
            header="Approve Request Modal"
            onClose={() => setShowApproveModal(false)}
          >
            {selectedRequest && (
              <div className="p-grid p-fluid transaction">
                <div style={{ marginBottom: "24px" }}>
                  <h4>Are you sure you want to approve this request?</h4>
                  <div className="p-mb-3">
                    <>Request ID:</> {selectedRequest.id}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "16px",
                      width: "100%",
                    }}
                  >
                    {actionLoading && (
                      <ProgressSpinner
                        style={{
                          width: "30px",
                          height: "30px",
                          marginBottom: "12px",
                        }}
                        strokeWidth="4"
                        animationDuration=".5s"
                      />
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "12px",
                        marginTop: "16px",
                        width: "100%",
                      }}
                    >
                      <Button
                        label="Confirm"
                        className="p-button-success"
                        onClick={() => confirmAction(selectedRequest.id)}
                        disabled={actionLoading}
                      />
                      <Button
                        label="Cancel"
                        className="p-button-info p-ml-2"
                        onClick={() => setShowApproveModal(false)}
                        disabled={actionLoading}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </CustomDialog>
          <CustomDialog
            visible={showDeclineModal}
            header="Decline Request Modal"
            onClose={() => setShowDeclineModal(false)}
          >
            {selectedRequest && (
              <div className="p-grid p-fluid transaction">
                <div style={{ marginBottom: "24px" }}>
                  <h4>Are you sure you want to decline this request?</h4>
                  <div className="p-mb-3">
                    <>Request ID:</> {selectedRequest.id}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "16px",
                      width: "100%",
                    }}
                  >
                    {actionLoading && (
                      <ProgressSpinner
                        style={{
                          width: "30px",
                          height: "30px",
                          marginBottom: "12px",
                        }}
                        strokeWidth="4"
                        animationDuration=".5s"
                      />
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "12px",
                        marginTop: "16px",
                        width: "100%",
                      }}
                    >
                      <Button
                        label="Confirm"
                        className="p-button-danger"
                        onClick={() => confirmAction(selectedRequest.id)}
                        disabled={actionLoading}
                      />
                      <Button
                        label="Cancel"
                        className="p-button-info"
                        disabled={actionLoading}
                        onClick={() => setShowDeclineModal(false)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </CustomDialog>
        </>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    userDetails: state.login.userDetails,
  };
};

export default connect(mapStateToProps, null)(TransactionStatusUpdateReq);
